import React from 'react';
import BWAccordion from 'components/shared/BWAccordion';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormItem from 'components/shared/BWFormControl/FormItem';

const WarrantyPeriodInformation = ({ disabled }) => (
  <BWAccordion title='Thông tin thời hạn bảo hành'>
    <div className='bw_row'>
      <FormItem className='bw_col_12' label='Số tháng bảo hành' isRequired disabled={disabled}>
        <FormInput
          field='period'
          type='number'
          min={1}
          max={1200}
          disabled={disabled}
          placeholder='Nhập số tháng bảo hành'
          validation={{
            required: 'Số tháng bảo hành là bắt buộc.',
            min: { value: 1, message: 'Số tháng bảo hành phải lớn hơn 0.' },
            max: { value: 1200, message: 'Số tháng bảo hành không được vượt quá 1200.' },
          }}
        />
      </FormItem>
    </div>
  </BWAccordion>
);

export default WarrantyPeriodInformation;
